<template>
	<div>
		<DetailCard
			v-if="item"
			:headContent="payContent"
			:detailContent="detailContent"
			:detailLarge="true"
		>
			<template v-slot:title>
				<div class="column col-auto">{{ title }}</div>
			</template>
		</DetailCard>
	</div>
</template>

<script>
import DetailCard from '@/components/common/DetailCard';

import { numberWithCommas, formatDateString } from '@/utils/util';

export default {
	components: {
		DetailCard,
	},
	props: {
		item: {
			type: Object,
			default: () => {},
			required: true,
		},
	},
	computed: {
		payContent() {
			return {
				name: '결제 금액',
				value: `${numberWithCommas(this.item.AMT)}원`,
			};
		},
		detailContent() {
			const period = `
			${this.item.START_DT === '-' ? '-' : formatDateString(this.item.START_DT)}
			~
			${this.item.END_DT === '-' ? '-' : formatDateString(this.item.END_DT)}`;

			return [
				{
					name: '계약 지점',
					value: this.item.DEPT_NAME,
				},
				{
					name: '계약 구분',
					value: this.item.GUBUN,
				},
				{
					name: '계약 상세',
					value: this.item.LIST_DESC,
				},
				{
					name: '사용 기간',
					value: period,
				},
			];
		},
		title() {
			return `계약 일자 : ${formatDateString(this.item.CONFIRM_DT)}`;
		},
	},
};
</script>
